<template>
  <form action="" class="gh-form gh-form--inline gh-main__repos__search">
    <div class="gh-form__group">
      <input
        type="search"
        name=""
        placeholder="Find a repository..."
        class="gh-form__input"
        id=""
      />
    </div>
    <a href="" class="gh-btn gh-btn--light"
      ><span class="grey">Type:</span>&nbsp;All&nbsp;<feather
        type="chevron-down"
        class="caret"
    /></a>
    <a href="" class="gh-btn gh-btn--light ml-1"
      ><span class="grey">Language:</span>&nbsp;All&nbsp;
      <feather type="chevron-down" class="caret"
    /></a>
    <a href="" class="gh-btn gh-btn--primary ml-1"
      ><feather type="book" class="icon" />&nbsp;New</a
    >
  </form>
</template>

<script>
export default {
  name: "search"
};
</script>

<style></style>
